import { Entity, IEntity } from "./Entity";
import { IUser } from "./User";
import { IZCoreUserGroup } from "./ZCoreUserGroup";


export interface IZCoreUserGroupMember extends IEntity {
    UserID?: number;
    ZCoreUserGroupID?: number;
    User?: IUser;
    ZCoreUserGroup?: IZCoreUserGroup;
}

export class ZCoreUserGroupMember extends Entity implements IZCoreUserGroupMember {
    public UserID = null;
    public ZCoreUserGroupID = null;
}